import { NavbarList } from '@models/entities/general/general';
import { ROUTES_ADMIN } from './routes';
import { ROLES_ADMIN } from './roles';

const operation = {name: 'navbar.operations', route: ROUTES_ADMIN.MONITOR_ROUTE, icon: 'map-marked', privilegeName: ROLES_ADMIN.MONITOR },
drivers = {name: 'navbar.control.drivers', route: ROUTES_ADMIN.DRIVERS_ROUTE, icon: 'drivers', privilegeName: ROLES_ADMIN.DRIVERS },
roles = {name: 'navbar.control.roles', route: ROUTES_ADMIN.ROLES_ROUTE, icon: 'clipboard', privilegeName: ROLES_ADMIN.ROLES },
tickets = {name: 'navbar.ticketOffice', route: ROUTES_ADMIN.TICKETS_ROUTE, icon: 'ticket', privilegeName: ROLES_ADMIN.TICKETS },
logistic = {name: 'navbar.logistic', route: ROUTES_ADMIN.LOGISTIC_ROUTE, icon: 'logistic', privilegeName: ROLES_ADMIN.LOGISTIC },
loyalty = {name: 'navbar.loyalty', route: ROUTES_ADMIN.LOYALTY_ROUTE, icon: 'loyalty.svg', privilegeName: ROLES_ADMIN.LOYALTY },
routes = {name: 'navbar.maintance.routes', route: ROUTES_ADMIN.ROUTES_ROUTE, icon: 'route', privilegeName: ROLES_ADMIN.ROUTES },
units = {name: 'navbar.maintance.units', route: ROUTES_ADMIN.UNITS_ROUTE, icon: 'bus-solid', privilegeName: ROLES_ADMIN.UNITS };

const account = {name: 'header.passerAccount', route: ROUTES_ADMIN.PROFILE_ROUTE, privilegeName: ROLES_ADMIN.PROFILE},
collection = {name: 'header.collectLiquidation', route: ROUTES_ADMIN.TRANSACTIONS_ROUTE, privilegeName: ROLES_ADMIN.PAYMENT_SYSTEM},
copny = {name: 'header.subscriptionProfile', route: ROUTES_ADMIN.COPNY_ROUTE, privilegeName: ROLES_ADMIN.COPNY},
office = {name: 'header.ofice', route: ROUTES_ADMIN.OFFICE_ROUTE, privilegeName: ROLES_ADMIN.OFFICE};
// validators = {name: 'header.valid_pos', route: ROUTES_ADMIN.VALID_POS};
const stats = {name: 'header.stats', route: ROUTES_ADMIN.STATS_ROUTE, icon: 'stats', privilegeName: ROLES_ADMIN.STADISTIC};

export const NAV_LEVEL_LIST: NavbarList = {
  admin: {
    topNav : [drivers, roles, tickets, logistic, loyalty, routes, units, operation],
    bottomNav: [account, collection, copny, office] // , validators
  },
  seller: {
    topNav : [roles, tickets, logistic, operation],
    bottomNav: [account]
  },
  enroller: {
    topNav : [drivers, roles, units, operation],
    bottomNav: [account]
  },
  analyst: {
    topNav : [operation],
    bottomNav: [account] // TODO - stadistic module
  },
  mechanic: {
    topNav : [roles, units, operation],
    bottomNav: [account] // TODO - mechanic module
  },
};

export const accessLevelTop = {
  drivers,
  roles,
  tickets,
  logistic,
  loyalty,
  routes,
  units,
  operation,
  account,
  collection,
  copny,
  office,
  stats
};
